module.exports = __webpack_public_path__ + "img/9788997066087.c3330bac.jpg";